import { AppRouteRecordRaw } from '../types';

const ORDER: AppRouteRecordRaw = {
  path: '/order',
  name: 'order',
  component: () => import('@/layout/default-layout.vue'),
  meta: {
    locale: '订单管理',
    icon: 'icon-file',
    order: 9,
    requiresAuth: true,
    hideInMenu: false,
  },
  children: [
    {
      path: 'reconciliation',
      name: 'Reconciliation',
      component: () => import('@/views/order/reconciliation/index.vue'),
      meta: {
        locale: '对账管理',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'reconciliation/records',
      name: 'ReconciliationRecords',
      component: () => import('@/views/order/reconciliation/records.vue'),
      meta: {
        locale: '对账记录',
        requiresAuth: true,
        roles: ['*'],
        hideInMenu: true,
      },
    },
    {
      path: 'sync-reconciliation',
      name: 'SyncReconciliation',
      component: () => import('@/views/order/sync-reconciliation/index.vue'),
      meta: {
        locale: '同步对账',
        requiresAuth: true,
        roles: ['*'],
      },
    }
  ],
};

export default ORDER; 